import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.factoringError"],
  error => error
);
